import { useMemo } from 'react'

import { getListingHelpers, PropSharingListingWithFundingData, StockAllowance } from '@guiker/propsharing-shared'

export const useGetHelpers = (listing: PropSharingListingWithFundingData, stockAllowance?: StockAllowance) => {
  return useMemo(() => getListingHelpers(listing, stockAllowance), [listing, stockAllowance])
}
